// extracted by mini-css-extract-plugin
export default {"container":"rsDZMy","padding":"OAcMJT","scrollBarColor":"br4i_4"};